module.exports = __webpack_public_path__ + "static/media/ltc-icon.20ead52a.svg";